import { styled } from "@material-ui/core"

export const Wrapper = styled("div")(() => ({
  height: "100%",
  width: "100%"
}))
